module.exports = __webpack_public_path__ + "images/terms-of-use-agreement-500w.webp";